import React, { useState, useCallback, useEffect } from "react";
import { Container } from "./styles";
import CKEditor from "ckeditor4-react";

const StatefulTextEditor = (props) => {
  const handleChange = useCallback(
    ({ editor }) => {
      const data = editor.getData();
      props.handleChange(data);
    },
    [props]
  );

  return (
    <Container>
      <style>{`
        .cke_button_label {
          display: none !important;
        }

        .cke_toolbar {
          display: flex !important;
          justify-content: space-around !important;
        }

        [class$="_label"] {
          display: none !important;
        }

        #cke_1_toolbox { 
          display: flex !important;
        }
      `}</style>
      <CKEditor data={props.default} onChange={handleChange} />
    </Container>
  );
};

export default StatefulTextEditor;
